import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import ReactInputMask from 'react-input-mask';
import Typewriter from 'typewriter-effect';
import AudioFormFillControl from "../components/audio-form-fill-control";
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from '../data/InteractionModel';
import { SignupModelHelper } from "../data/SignupModel";
import { dataLayerHelper } from "../data/dataLayerModel";
import { months } from '../data/months';
import { AmplitudeService } from '../services/AmplitudeService';

export default function Nascimento() {


  const [value, setValue] = useState('');
  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [gender, setGender] = useState('');

  function handleChange(e: React.FormEvent<HTMLInputElement>) {
    setValue(e.currentTarget.value);
  }

  useEffect(() => {
    // TagManager.dataLayer(dataLayerHelper.pagina('nascimento', 'cadastro-usuario'));
    AmplitudeService.track('Birthday Screen')

    const signup = SignupModelHelper.get();
    if (signup) {
      setGender(signup.gender);
    } else {
      document.location = './';
    }
  }, [])


  function dateDiffInYears(dateold: Date, datenew: Date) {
    var ynew = datenew.getFullYear();
    var mnew = datenew.getMonth();
    var dnew = datenew.getDate();
    var yold = dateold.getFullYear();
    var mold = dateold.getMonth();
    var dold = dateold.getDate();
    var diff = ynew - yold;
    if (mold > mnew) diff--;
    else {
      if (mold === mnew) {
        if (dold > dnew) diff--;
      }
    }
    return diff;
  }

  function handleSubmit() {
    const dateStringISO = value.split('/').reverse().join('-');

    const birthdate = new Date(dateStringISO + "T12:00");

    const today = new Date();
    today.setHours(12);

    const chat = [...interactions, {
      text: `${birthdate.getDate()} de ${months[birthdate.getMonth()]} de ${birthdate.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(birthdate.getTime()) || birthdate.getFullYear() < 1900) {
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${today.getFullYear()}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (dateDiffInYears(birthdate, today) < 16) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `É necessário ter 16 (dezesseis) anos completos para prosseguir com o cadastro.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else {

      TagManager.dataLayer(dataLayerHelper.measureClick('data-nascimento', 'mes'));
      SignupModelHelper.update({
        birthdate: birthdate,
      });
      AmplitudeService.track('Birthday Submit', { birthday: birthdate, age: dateDiffInYears(birthdate, today) })

      document.location = '#/endereco';
    }
  }

  return (
    <>
      <Header step={ 5 } total={ 12 } title="Seu nascimento" previous="#/genero"></Header>

      <div className="chat-container">

        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">


                <div className="chat-item chat-item-user">
                  <img src="images/ico-chat-user.svg" alt="Usuário" />
                  <div className="chat-item-content">
                    <p>
                      { gender }
                    </p>
                  </div>
                </div>


                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter.changeDelay(15).typeString('Agora eu preciso saber a <strong>data do seu nascimento</strong>.')
                          .start();
                      } } />
                  </div>
                </div>

                {
                  interactions.map((interaction, index) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ index + interaction.text }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ index + interaction.text }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }

              </div>
            </div>
          </div>
        </div>

        <footer className="footer-answer">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <form onSubmit={ handleSubmit } className="footer-answer-holder d-flex align-items-center justify-content-between">

                  <ReactInputMask mask="99/99/9999" placeholder="Informa a data: DD/MM/AAAA" value={ value } onChange={ handleChange } />
                  <AudioFormFillControl
                    fields={ [{ key: 'birthDate', label: 'Data de nascimento' }] }
                    onApply={ (values) => setValue(values.birthDate || '') }
                  />

                  <button type="submit" className="btn-submit" disabled={ value.length < 10 }>
                    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>);
}
